import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/channels")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
